import { Dashboard } from "./Dashboard";
import { useAuth } from "./lib/auth";

export default function App() {
  const { principal, loading } = useAuth();

  return (
    <main style={{ fontFamily: "system-ui, sans-serif", padding: "1rem", maxWidth: 1400, margin: "0 auto" }}>
      <header style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "1rem", borderBottom: "1px solid #eee", paddingBottom: "0.5rem" }}>
        <h1 style={{ margin: 0 }}>WeatherRelay ☀️</h1>
        <small style={{ color: "#666" }}>
          {loading
            ? "loading…"
            : principal
              ? `${principal.name} · ${principal.kind} · scopes: ${principal.scopes.join(", ")}`
              : "unauthenticated"}
        </small>
      </header>
      <Dashboard />
    </main>
  );
}
